export const BYTES_TO_KB = 1000;
export const BYTES_TO_MB = 1000 * 1000;
export const KB_TO_MB = 1024;
export const MB_TO_KB = 1024;

export const FC_VERT = {
  display: "flex",
  alignItems: "center",
};

export const FC_ALL = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const F_BETWEEN = {
  ...FC_VERT,
  justifyContent: "space-between",
};
